export type TMultiSplitPaymentStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'ERROR'
  | 'SUCCESS';

export type TMultiSplitPaymentError = {
  code: string;
  message: string;
};

export type TMultiSplitPaymentExternalBankAccount = {
  bank_account: string;
  bank_account_digit: string;
  bank_account_type: string;
  bank_branch: string;
  bank_code: string;
  ispb_code: string;
};

export type TMultiSplitPaymentHolder = {
  name: string;
  taxpayer_id: string;
};

export type TMultiSplitPaymentPix = {
  key: string;
  key_type: string;
};

export type TMultiSplitPayment = {
  absolute_amount: number;
  created_at: string;
  error?: TMultiSplitPaymentError | null;
  external_bank_account: TMultiSplitPaymentExternalBankAccount | null;
  holder: TMultiSplitPaymentHolder;
  id: string;
  account_id?: string | null;
  percentage_amount: number | null;
  pix: TMultiSplitPaymentPix | null;
  status: TMultiSplitPaymentStatus;
  updated_at: string;
};

export type TMultiSplitPaymentsResponse = {
  content: TMultiSplitPayment[];
  has_next: boolean;
  page: number;
  size: number;
  total_elements: number;
  total_pages: number;
};

export const DEFAULT_PAYMENT_PAGE_SIZE = 20;
export const PAYMENT_PAGE_SIZE_OPTIONS = [10, 20];

export const getEmptyPaymentsResponse = (
  page = 0,
  size = DEFAULT_PAYMENT_PAGE_SIZE,
): TMultiSplitPaymentsResponse => ({
  content: [],
  has_next: false,
  page,
  size,
  total_elements: 0,
  total_pages: 0,
});

export type TUpdatePaymentAccountPayload = {
  holder: TMultiSplitPaymentHolder;
  pix?: TMultiSplitPaymentPix;
  external_bank_account?: TMultiSplitPaymentExternalBankAccount;
};

export type TPayoutReceipt = {
  payout_id: string;
  status: string;
  amount: number;
  created_at: string;
  links: {
    json: string;
    pdf: string;
  };
};

export type TPayoutReceiptResponse = {
  application_id: string;
  receipts: TPayoutReceipt[];
};
